import React from 'react';

const ReviewSubmit = ({ formData, prevStep, handleSubmit }) => {
  return (
    <div>
      <h2 className="text-2xl font-semibold mb-6">Review & Submit</h2>
      <p className="mb-6 text-gray-600">
        Please review your information before submitting.
      </p>
      
      <div className="space-y-6">
        {/* Resident Information */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h3 className="text-lg font-medium mb-3">Resident Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-500">Block & Flat</p>
              <p className="font-medium">Block {formData.block}, Flat {formData.flatNumber}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Resident Name</p>
              <p className="font-medium">{formData.residentName}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Resident Type</p>
              <p className="font-medium capitalize">{formData.residentType}</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Mobile Number</p>
              <p className="font-medium">{formData.mobileNumber}</p>
            </div>
            {formData.email && (
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="font-medium">{formData.email}</p>
              </div>
            )}
          </div>
        </div>
        
        {/* Vehicle Information */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h3 className="text-lg font-medium mb-3">Vehicle Information</h3>
          {formData.vehicles.length > 0 ? (
            <div className="space-y-4">
              {formData.vehicles.map((vehicle, index) => (
                <div key={vehicle.id} className="border-t border-gray-200 pt-3 first:border-t-0 first:pt-0">
                  <h4 className="font-medium mb-2">Vehicle {index + 1}</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <p className="text-sm text-gray-500">Type</p>
                      <p>{vehicle.type}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Registration Number</p>
                      <p>{vehicle.registrationNumber}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Make & Model</p>
                      <p>{vehicle.make} {vehicle.model}</p>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Color</p>
                      <p>{vehicle.color}</p>
                    </div>
                    {vehicle.insuranceExpiry && (
                      <div>
                        <p className="text-sm text-gray-500">Insurance Expiry</p>
                        <p>{vehicle.insuranceExpiry}</p>
                      </div>
                    )}
                    <div>
                      <p className="text-sm text-gray-500">Owner Name</p>
                      <p>{vehicle.ownerName}</p>
                    </div>
                    {vehicle.isPrimaryVehicle && (
                      <div className="col-span-2">
                        <span className="inline-block px-2 py-1 text-xs font-semibold bg-blue-100 text-blue-800 rounded">
                          Primary Vehicle
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-red-600">No vehicles added. Please go back and add at least one vehicle.</p>
          )}
        </div>
        
        {/* Security & Access */}
        <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
          <h3 className="text-lg font-medium mb-3">Security & Access</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {formData.rfidTagNumber && (
              <div>
                <p className="text-sm text-gray-500">RFID Tag Number</p>
                <p className="font-medium">{formData.rfidTagNumber}</p>
              </div>
            )}
            {formData.emergencyContact && (
              <div>
                <p className="text-sm text-gray-500">Emergency Contact</p>
                <p className="font-medium">{formData.emergencyContact}</p>
              </div>
            )}
            {formData.parkingSlotNumbers.length > 0 && (
              <div className="col-span-2">
                <p className="text-sm text-gray-500">Parking Slots</p>
                <p className="font-medium">{formData.parkingSlotNumbers.join(', ')}</p>
              </div>
            )}
            {formData.remarks && (
              <div className="col-span-2">
                <p className="text-sm text-gray-500">Additional Remarks</p>
                <p className="font-medium">{formData.remarks}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      
      <form onSubmit={handleSubmit} className="mt-8">
        <div className="flex justify-between">
          <button
            type="button"
            onClick={prevStep}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Back
          </button>
          
          <button
            type="submit"
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-6 rounded focus:outline-none focus:shadow-outline"
          >
            Submit Registration
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReviewSubmit;
